import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RowCompStadium from './RowCompStadium';


import Table from 'react-bootstrap/Table';



class TableStadiumGroup extends React.Component {


render(){


  return(
    <Row className="justify-content-md-center">
    <Col lg={6} xl={6}  >
    <Table variant="dark" striped bordered hover size="sm">
  <thead>
    <tr style={{textAlign: 'center' }}>
      <th>Estadio</th>
      <th>PJ</th>
      <th>PG</th>
      <th>PE</th>
      <th>PP</th>
      <th>GF</th>
      <th>GC</th>
      <th>DIF</th>
    </tr>
  </thead>
  <tbody>
    {this.props.stadium_list.map((stadium, i) => {
                   return ( <RowCompStadium key={stadium['path']} shortname={stadium['path']} name={stadium['name']} country={stadium['country']}  ></RowCompStadium>  )
            })}
</tbody>
</Table>
</Col>
</Row>
  )
}
}
export default TableStadiumGroup;
